import React from 'react'
import { FormatUtcDateAsLocal } from '../../../../../../helpers/datetime'
import * as Badges from '../../../../../../components/badges'
import PropTypes from "prop-types"

const PoolUpdated = (props) => {
  return <tr>
    <td><Badges.PoolUpdated /></td>
    <td>Pool updated</td>
    <td>{FormatUtcDateAsLocal(props.item.createdUtc)}</td>
    <td>{props.item.createdBy}</td>
  </tr>
}

PoolUpdated.propTypes = {
  item: PropTypes.object
}

export default PoolUpdated


// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/poolUpdated/index.js